import createModel from 'models/lib/create_model';

export default createModel({
  modelName: 'VoiceCampaignOutreach',

  properties: {
    campaignId: String,
    name: String,
    description: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/voice_campaign_outreach.js